var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"videobox"},[_c('div',{staticClass:"close",on:{"click":function($event){return _vm.$emit('closeVideoBox')}}},[_vm._v("x")]),_c('div',{staticStyle:{"height":"100%","width":"100%"},domProps:{"innerHTML":_vm._s(_vm.urls)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }